export const DEFAULT_PRO_ACCOUNT_PRICE = 99;

/**
 * Must match the value in Firestore at path `config/app.version`
 */
export const APP_VERSION = 7;

export const SUPPORT_EMAIL = "support@aircap.tech";
